/** Core strings: app, auth, navigation, team, profile, library. */
export const core = {
  'app.name': 'brao',
  'common.loading': 'Завантаження…',
  'common.error': 'Сталася помилка',
  'common.save': 'Зберегти',
  'common.cancel': 'Скасувати',
  'common.close': 'Закрити',
  'common.copy': 'Копіювати',
  'common.copied': 'Скопійовано',
  'common.menu': 'Меню',
  'common.yes': 'Так',
  'common.no': 'Ні',
  'common.none': 'Немає',
  'common.phase': 'Цей розділ з’явиться у фазі {n}.',

  'auth.login.title': 'Вхід',
  'auth.login.email': 'Електронна пошта',
  'auth.login.password': 'Пароль',
  'auth.login.submit': 'Увійти',
  'auth.login.error': 'Невірна пошта або пароль',
  'auth.2fa.title': 'Другий фактор',
  'auth.2fa.hint': 'Введи код із застосунку-автентифікатора або один із резервних кодів.',
  'auth.2fa.code': 'Код',
  'auth.2fa.submit': 'Підтвердити',
  'auth.2fa.error': 'Невірний код',
  'auth.logout': 'Вийти',

  'nav.overview': 'Огляд',
  'nav.tasks': 'Задачі',
  'nav.plans': 'Плани',
  'nav.approvals': 'Затвердження',
  'nav.agents': 'Агенти',
  'nav.knowledge': 'Знання',
  'nav.processes': 'Процеси',
  'nav.runs': 'Прогони',
  'nav.finance': 'Фінанси',
  'nav.team': 'Команда',
  'nav.audit': 'Аудит',
  'nav.profile': 'Профіль',

  'home.title': 'Огляд',

  'team.title': 'Команда',
  'team.members': 'Учасники',
  'team.col.name': 'Ім’я',
  'team.col.type': 'Тип',
  'team.col.email': 'Пошта',
  'team.col.roles': 'Ролі',
  'team.col.businesses': 'Бізнеси',
  'team.col.2fa': '2FA',
  'team.col.lastLogin': 'Останній вхід',
  'team.type.human': 'людина',
  'team.type.agent': 'агент',
  'team.invites': 'Запрошення',
  'team.invite.new': 'Запросити людину',
  'team.invite.email': 'Пошта',
  'team.invite.role': 'Роль',
  'team.invite.businesses': 'Доступ до бізнесів',
  'team.invite.submit': 'Створити запрошення',
  'team.invite.link': 'Посилання для запрошеного (діє 7 днів). Надішли його сама, пошта ще не підключена.',
  'team.invite.pending': 'Очікують прийняття',
  'team.invite.expires': 'Діє до',
  'team.keys': 'Ключі й доступи',
  'team.keys.hint': 'Секрети зберігаються зашифрованими; після збереження їх не можна переглянути, лише замінити.',
  'team.keys.add': 'Додати ключ',
  'team.keys.provider': 'Сервіс',
  'team.keys.name': 'Назва',
  'team.keys.secret': 'Секрет',
  'team.keys.scope': 'Область (необов’язково)',
  'team.keys.rotate': 'Замінити',
  'team.keys.revoke': 'Відкликати',
  'team.keys.revoked': 'відкликано',
  'team.keys.rotated': 'замінено',
  'team.keys.created': 'створено',
  'team.keys.confirmRevoke': 'Відкликати цей ключ? Коннектори, що ним користуються, перестануть працювати.',

  'invite.title': 'Запрошення до brao',
  'invite.for': 'Запрошення для',
  'invite.role': 'Роль',
  'invite.name': 'Як тебе називати',
  'invite.password': 'Пароль (не менше 10 символів)',
  'invite.submit': 'Створити акаунт',
  'invite.invalid': 'Запрошення недійсне або прострочене.',
  'invite.done': 'Акаунт створено. Тепер можна увійти.',
  'invite.goLogin': 'Перейти до входу',

  'profile.title': 'Профіль',
  'profile.2fa': 'Двофакторна автентифікація',
  'profile.2fa.on': 'Увімкнено',
  'profile.2fa.off': 'Вимкнено',
  'profile.2fa.start': 'Увімкнути',
  'profile.2fa.scan': 'Відскануй QR у застосунку (Google Authenticator, 1Password, Authy) або введи секрет вручну.',
  'profile.2fa.secret': 'Секрет',
  'profile.2fa.confirm': 'Код із застосунку',
  'profile.2fa.enable': 'Підтвердити й увімкнути',
  'profile.2fa.recovery': 'Резервні коди. Збережи їх зараз: показуються лише один раз. Кожен працює один раз.',
  'profile.2fa.disable': 'Вимкнути',
  'profile.2fa.disableHint': 'Щоб вимкнути, введи поточний код із застосунку.',

  'agents.title': 'Агенти',
  'agents.library': 'Бібліотека',
  'agents.library.hint': 'Шаблони ролей, навички й рецепти як контент-пакет JSON: резервна копія й перенесення між інсталяціями.',
  'agents.library.export': 'Експортувати пакет',
  'agents.library.import': 'Імпортувати пакет',
  'agents.library.importResult': 'Імпорт: шаблонів {t}, навичок {s}, рецептів {r} (створено/оновлено/пропущено).',
  'agents.library.history': 'Історія пакетів',
  'agents.library.col.when': 'Коли',
  'agents.library.col.name': 'Назва',
  'agents.library.col.direction': 'Напрям',
  'agents.library.col.checksum': 'Контрольна сума',
  'agents.library.export.dir': 'експорт',
  'agents.library.import.dir': 'імпорт',
} as const;
